<template>
  <div class="" @click="show">
    <slot></slot>
    <teleport to="body">
      <div v-if="isShow" class="keyboard">
        <div class="txt-bg">
          <div class="txt-input-msg">{{ msg }}</div>
          <div class="txt-input">
            {{ isPassword ? modelValueShowShow : modelValueShow }}
          </div>
        </div>
        <div class="keys-bg">
          <div class="keys">
            <div class="keys-top">
              <div class="keys-left">
                <div
                  v-for="(item, index) in keysLeft"
                  :key="index"
                  class="key key-num"
                  :data-key="item.value"
                  @click="input"
                >
                  {{ item.value }}
                </div>
              </div>
              <div class="keys-right">
                <div class="key key-dele" @click="dele">
                  <div class="key-dele-icon"></div>
                </div>
                <div class="key key-esc" @click="hide">ESC</div>
              </div>
            </div>
            <div class="keys-bottom">
              <div class="key key-num" data-key="0" @click="input">0</div>
              <div class="key key-num" data-key="." @click="input">.</div>
              <div class="key key-num" data-key="-" @click="input">-</div>
              <div class="key key-ok" @click="ok">OK</div>
            </div>
          </div>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script>
export default {
  name: "Page",
  props: [
    "modelValue",
    "isPassword",
    "isCustom",
    "msg",
    "isControl",
    "ip",
    "disabled",
  ],
  emits: ["update:modelValue"],
  components: {},
  data() {
    return {
      modelValueShow: "",
      isShow: false,
      keysLeft: [
        { t: "num", value: 7 },
        { t: "num", value: 8 },
        { t: "num", value: 9 },
        { t: "num", value: 4 },
        { t: "num", value: 5 },
        { t: "num", value: 6 },
        { t: "num", value: 1 },
        { t: "num", value: 2 },
        { t: "num", value: 3 },
      ],
      keysRight: [
        { t: "dele", value: "" },
        { t: "esc", value: "" },
      ],
      keysRight: [
        { t: "num", value: 0 },
        { t: "num", value: "." },
        { t: "ok", value: "" },
      ],
    };
  },
  computed: {
    modelValueShowShow() {
      let a = [];
      a.length = this.modelValueShow.length;
      return a.join("*") + (a.length > 0 ? "*" : "");
    },
  },
  methods: {
    dele() {
      this.modelValueShow = this.modelValueShow.slice(
        0,
        this.modelValueShow.length - 1
      );
    },
    input(e) {
      // console.log(e.currentTarget.dataset.key);
      let key = "" + e.currentTarget.dataset.key;
      if (!this.ip && this.modelValueShow.indexOf(".") != -1 && key == ".") {
        return;
      }
      // if (this.modelValueShow == "0" && key != ".") {
      //   return;
      // }
      this.modelValueShow = this.modelValueShow + key;
    },
    show() {
      if (this.disabled) {
        return;
      }
      if (this.isControl) {
        return;
      }
      // console.log("show???");
      // console.log(this.modelValue);
      // console.log(typeof this.modelValue);
      this.modelValueShow =
        "" + (this.modelValue != undefined ? this.modelValue : "");

      this.isShow = true;
    },
    ok() {
      // console.log("modevalue?");
      // console.log(this.modelValue);
      // console.log(typeof this.modelValue);
      let result;
      if (this.modelValueShow) {
        if (this.isPassword || this.ip) {
          result = this.modelValueShow;
        } else {
          result = parseFloat(this.modelValueShow);
        }
      } else {
        result = "";
      }
      if (this.isCustom) {
        this.$emit("ok", result);
      } else {
        this.$emit("update:modelValue", result);
        this.isShow = false;
      }
    },
    hide() {
      this.isShow = false;
    },
  },
  mounted() {},
};
</script>
<style scoped lang="less" src="./index.less"></style>
